export default {

    firstDayOfMonth(date) {

        let theDate = new Date(date);
        theDate.setDate(1);
        theDate.setHours(0, 0, 0, 0);

        return theDate;
    },

    lastDayOfMonth(date) {

        let theDate = new Date(date);

        theDate.setMonth(theDate.getMonth() + 1);
        theDate.setDate(0);

        return theDate;
    },

    formatToDateString(date) {
        const theDate = new Date(date)
        const day = theDate.getDate();
        const month = theDate.getMonth() + 1;
        return `${day < 10 ? "0" : ""}${day}-${month < 10 ? "0" : ""}${month}-${theDate.getFullYear()}`
    },

    formatToTimeString(date) {
        const theDate = new Date(date);
        const hours = theDate.getHours();
        const minutes = theDate.getMinutes();
        return `${hours < 10 ? "0" : ""}${hours}:${minutes < 10 ? "0" : ""}${minutes}`
    },

    addYears(date, numberOfYears) {
        const copy = new Date(date);
        copy.setFullYear(copy.getFullYear() + numberOfYears);
        return copy;
    }
}